import loadable from '@loadable/component';
import { PAGE_TYPES } from './constants';
import { setCartCount, incrementCartCount, removeShowCartMerge, setShowCartMerge } from './helpers';

export { PAGE_TYPES, setCartCount, incrementCartCount, removeShowCartMerge, setShowCartMerge };
export default loadable(() => import(/* webpackChunkName: "cart-merge" */ './CartMerge'));
